/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Token_Warning_Elevated_Risk_TitleInputs */

const en_shared_token_warning_elevated_risk_title = /** @type {(inputs: Shared_Token_Warning_Elevated_Risk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevated market risk`)
};

const de_shared_token_warning_elevated_risk_title = /** @type {(inputs: Shared_Token_Warning_Elevated_Risk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhöhtes Marktrisiko`)
};

const pt_br2_shared_token_warning_elevated_risk_title = /** @type {(inputs: Shared_Token_Warning_Elevated_Risk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risco de mercado elevado`)
};

const tr_shared_token_warning_elevated_risk_title = /** @type {(inputs: Shared_Token_Warning_Elevated_Risk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüksek piyasa riski`)
};

const zh_cn2_shared_token_warning_elevated_risk_title = /** @type {(inputs: Shared_Token_Warning_Elevated_Risk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场风险偏高`)
};

const zh_hk2_shared_token_warning_elevated_risk_title = /** @type {(inputs: Shared_Token_Warning_Elevated_Risk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市場風險偏高`)
};

const ko_kr2_shared_token_warning_elevated_risk_title = /** @type {(inputs: Shared_Token_Warning_Elevated_Risk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시장 리스크 상승`)
};

const ru_ru2_shared_token_warning_elevated_risk_title = /** @type {(inputs: Shared_Token_Warning_Elevated_Risk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повышенный рыночный риск`)
};

const es_419_shared_token_warning_elevated_risk_title = /** @type {(inputs: Shared_Token_Warning_Elevated_Risk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riesgo de mercado elevado`)
};

/**
* | output |
* | --- |
* | "Elevated market risk" |
*
* @param {Shared_Token_Warning_Elevated_Risk_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const shared_token_warning_elevated_risk_title = /** @type {((inputs?: Shared_Token_Warning_Elevated_Risk_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Token_Warning_Elevated_Risk_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_token_warning_elevated_risk_title(inputs)
	if (locale === "de") return de_shared_token_warning_elevated_risk_title(inputs)
	if (locale === "pt-BR") return pt_br2_shared_token_warning_elevated_risk_title(inputs)
	if (locale === "tr") return tr_shared_token_warning_elevated_risk_title(inputs)
	if (locale === "zh-CN") return zh_cn2_shared_token_warning_elevated_risk_title(inputs)
	if (locale === "zh-HK") return zh_hk2_shared_token_warning_elevated_risk_title(inputs)
	if (locale === "ko-KR") return ko_kr2_shared_token_warning_elevated_risk_title(inputs)
	if (locale === "ru-RU") return ru_ru2_shared_token_warning_elevated_risk_title(inputs)
	return es_419_shared_token_warning_elevated_risk_title(inputs)
});